import { useTranslation as e } from "@maat/store-i18n";
//#region src/suggestions/useSuggestedMessages.ts
var t = (t = "conversation") => {
	let { t: n } = e("chat"), r = [
		{
			label: n("emptyStates.suggestions.available.label"),
			body: n(t === "widget" ? "emptyStates.suggestions.available.widgetBody" : "emptyStates.suggestions.available.body")
		},
		{
			label: n("emptyStates.suggestions.scheduleVisit.label"),
			body: n("emptyStates.suggestions.scheduleVisit.body")
		},
		{
			label: n("emptyStates.suggestions.pricing.label"),
			body: n("emptyStates.suggestions.pricing.body")
		}
	];
	return t === "conversation" && r.push({
		label: n("emptyStates.suggestions.area.label"),
		body: n("emptyStates.suggestions.area.body")
	}), r;
};
//#endregion
export { t as useSuggestedMessages };
